import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7dca3d2d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "simple-area-chart"
};
const _hoisted_2 = ["width", "height", "viewBox"];
const _hoisted_3 = ["y2"];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("stop", {
  "stop-color": "#D4BBFF",
  offset: "0%"
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("stop", {
  "stop-color": "#D4BBFF",
  "stop-opacity": "0.3",
  offset: "100%"
}, null, -1));
const _hoisted_6 = [_hoisted_4, _hoisted_5];
const _hoisted_7 = ["y2"];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("stop", {
  "stop-color": "#7C36F5",
  offset: "0%"
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("stop", {
  "stop-color": "#7C36F5",
  "stop-opacity": "1.0",
  offset: "100%"
}, null, -1));
const _hoisted_10 = [_hoisted_8, _hoisted_9];
const _hoisted_11 = ["d"];
const _hoisted_12 = ["d"];
const _hoisted_13 = ["d"];
const _hoisted_14 = {
  key: 1
};
const _hoisted_15 = ["d"];
const _hoisted_16 = ["cx", "cy"];
const _hoisted_17 = ["cx", "cy"];
const _hoisted_18 = {
  key: 2
};
const _hoisted_19 = ["d"];
const _hoisted_20 = ["cx", "cy"];
const _hoisted_21 = ["cx", "cy"];
const _hoisted_22 = {
  key: 3
};
const _hoisted_23 = ["d"];
const _hoisted_24 = ["cx", "cy"];
const _hoisted_25 = ["cx", "cy"];
const _hoisted_26 = {
  class: "value"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "circle-wrapper"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "circle-inner"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "circle-border"
})], -1));
const _hoisted_28 = {
  class: "label"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_date_value = _resolveComponent("date-value");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(), _createElementBlock("svg", {
    width: $props.width,
    height: $props.height,
    viewBox: `0 0 ${$props.width} ${$props.height + 1.5}`,
    fill: "none",
    ref: "chart",
    xmlns: "http://www.w3.org/2000/svg",
    onMousemove: _cache[0] || (_cache[0] = (...args) => $options.handleMouseMove && $options.handleMouseMove(...args)),
    onMouseleave: _cache[1] || (_cache[1] = (...args) => $options.handleMouseOut && $options.handleMouseOut(...args))
  }, [_createElementVNode("defs", null, [_createElementVNode("linearGradient", {
    id: "areaGradient",
    x1: "0",
    y1: 0,
    x2: "0",
    y2: $props.height,
    gradientUnits: "userSpaceOnUse"
  }, _hoisted_6, 8, _hoisted_3), _createElementVNode("linearGradient", {
    id: "highlightGradient",
    x1: "0",
    y1: "0",
    x2: "0",
    y2: $props.height,
    gradientUnits: "userSpaceOnUse"
  }, _hoisted_10, 8, _hoisted_7)]), _createElementVNode("path", {
    d: $options.areaPath,
    fill: "url(#areaGradient)",
    "fill-opacity": "0.4"
  }, null, 8, _hoisted_11), _createElementVNode("path", {
    d: $options.linePath,
    stroke: "#B885FF",
    "stroke-width": "0.75",
    "stroke-linecap": "round",
    fill: "none"
  }, null, 8, _hoisted_12), $options.highlightAreaPath ? (_openBlock(), _createElementBlock("path", {
    key: 0,
    d: $options.highlightAreaPath,
    stroke: "url(#highlightGradient)",
    "stroke-width": "0.75",
    "stroke-linecap": "round",
    fill: "none"
  }, null, 8, _hoisted_13)) : _createCommentVNode("", true), $options.highlightTooltipPoints.start ? (_openBlock(), _createElementBlock("g", _hoisted_14, [_createElementVNode("path", {
    d: `M ${$options.highlightTooltipPoints.start.x} 0 L ${$options.highlightTooltipPoints.start.x} ${$props.height}`,
    stroke: "#C2C2C2",
    "stroke-dasharray": "4 3",
    "stroke-width": "0.5"
  }, null, 8, _hoisted_15), _createElementVNode("circle", {
    cx: $options.highlightTooltipPoints.start.x,
    cy: $options.highlightTooltipPoints.start.y,
    r: "2",
    fill: "#9447FF"
  }, null, 8, _hoisted_16), _createElementVNode("circle", {
    cx: $options.highlightTooltipPoints.start.x,
    cy: $options.highlightTooltipPoints.start.y,
    r: "2.5",
    stroke: "white"
  }, null, 8, _hoisted_17)])) : _createCommentVNode("", true), $options.highlightTooltipPoints.end ? (_openBlock(), _createElementBlock("g", _hoisted_18, [_createElementVNode("path", {
    d: `M ${$options.highlightTooltipPoints.end.x} 0 L ${$options.highlightTooltipPoints.end.x} ${$props.height}`,
    stroke: "#C2C2C2",
    "stroke-dasharray": "4 3",
    "stroke-width": "0.5"
  }, null, 8, _hoisted_19), _createElementVNode("circle", {
    cx: $options.highlightTooltipPoints.end.x,
    cy: $options.highlightTooltipPoints.end.y,
    r: "2",
    fill: "#9447FF"
  }, null, 8, _hoisted_20), _createElementVNode("circle", {
    cx: $options.highlightTooltipPoints.end.x,
    cy: $options.highlightTooltipPoints.end.y,
    r: "2.5",
    stroke: "white"
  }, null, 8, _hoisted_21)])) : _createCommentVNode("", true), $data.tooltip ? (_openBlock(), _createElementBlock("g", _hoisted_22, [_createElementVNode("path", {
    d: `M ${$options.indicator.x} 0 L ${$options.indicator.x} ${$props.height}`,
    stroke: "#C2C2C2",
    "stroke-dasharray": "2 2",
    "stroke-width": "0.5"
  }, null, 8, _hoisted_23), _createElementVNode("circle", {
    cx: $options.indicator.x,
    cy: $options.indicator.y,
    r: "2",
    fill: "#9447FF"
  }, null, 8, _hoisted_24), _createElementVNode("circle", {
    cx: $options.indicator.x,
    cy: $options.indicator.y,
    r: "2.5",
    stroke: "white"
  }, null, 8, _hoisted_25)])) : _createCommentVNode("", true)], 40, _hoisted_2)), $data.tooltip ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "indicator-popover",
    ref: "popover",
    style: _normalizeStyle($options.popoverStyle)
  }, [_createVNode(_component_date_value, {
    value: $data.tooltip?.label,
    format: "MMM D, YYYY"
  }, null, 8, ["value"]), _createElementVNode("div", _hoisted_26, [_hoisted_27, _createElementVNode("div", _hoisted_28, _toDisplayString($options.coalesceNumber($data.tooltip?.value, 'No data available')), 1)])], 4)) : _createCommentVNode("", true)]);
}